export class MotivoRecusaModalService {

    static $inject = ['$uibModal'];

    constructor(
        private $uibModal: ng.ui.bootstrap.IModalService,
    ) {}

    public open(): ng.ui.bootstrap.IModalInstanceService {
        return this.$uibModal.open({
            template: require('html-loader!./motivo-recusa.modal.html'),
            controller: 'MotivoRecusaModalController',
            controllerAs: '$ctrl',
            windowClass: '',
            backdrop: 'static',
            resolve: {}
        });
    }
}
